// This icon file is generated automatically.
var PCloseCircleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "g", "attrs": { "fill-rule": "nonzero" }, "children": [{ "tag": "path", "attrs": { "d": "M9.7 4.54a.13.13 0 00-.12-.12H8.55L7 6.28 5.45 4.42H4.42a.12.12 0 00-.13.13c0 .03.01.05.03.08l2.03 2.42-2.03 2.42a.13.13 0 00.1.2h1.03L7 7.82l1.55 1.85h1.03c.07 0 .13-.05.13-.12a.13.13 0 00-.03-.08L7.65 7.05l2.03-2.42a.13.13 0 00.03-.09z" } }, { "tag": "path", "attrs": { "d": "M7 .02a7 7 0 100 14 7 7 0 000-14zm0 12.8A5.81 5.81 0 117 1.2a5.81 5.81 0 010 11.63z" } }] }] }, "name": "p-close-circle", "theme": "outlined" };
export default PCloseCircleOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PCloseCircleOutlined.js
// module id = 3282
// module chunks = 0